<template>
  <div class="file-list">
    <div class="mt-4" v-if="files.length" v-cloak>
      <div class="file-list__file" v-for="(file, index) in files">
        <div class="title">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/></svg>
          <span>{{ file.name }}</span>

          <app-toggle v-if="sharable" :active="isActive(index)" @change="(event) => onSharedChanged(event, index)" />
          <input :name="`shared[${index}]`" value="1" type="checkbox" v-model="shared[index]" v-show="false">

        </div>
        <div class="form-group" :class="{'has-error': hasError(index) }">
          <div class="input-group mb-3">
            <input class="form-control" name="names[]" v-model="names[index]" placeholder="Document naam" type="text">
            <span class="input-group-btn" v-if="removable">
                 <button class="btn btn-outline-secondary" type="button"  @click="$emit('remove', files.indexOf(file))">x</button>
              </span>
          </div>
          <div v-if="hasError(index)" class="text-danger">{{ errors[`files.${index}`][0] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentList",

  props: {
    files: {
      type: Array,
      default: [],
    },

    value: {
      type: Object,
      default: null,
    },

    sharable: {
      type: Boolean,
      default: true,
    },

    removable: {
      type: Boolean,
      default: true,
    },

    errors: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      shared: [],
      names: [],
    }
  },

  created() {
    this.files.forEach((file, index) => {
      this.names.push(file.name);

      Vue.set(this.shared, index, file.custom_properties.shared);
    });
  },

  watch: {
    names() {
      this.updateValue()
    },

    shares() {
      this.updateValue();
    },

    files(val, oldVal) {
      const newFiles = this.files.slice(oldVal.length);
      newFiles.forEach(file => {
        this.names.push(file.name);
        this.shared.push(false);
      });
    },
  },

  methods: {
    updateValue() {
      const values = {
        names: this.names,
        shares: this.shared,
      }

      this.$emit('input', values);
    },

    isActive(index) {
      return _.get(this.shared, index, false);
    },

    hasError(index) {
      return _.get(this.errors, `files.${index}`, false);
    },

    onSharedChanged(value, index) {
      Vue.set(this.shared, index, value);
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/documents/DocumentList.vue